import JumbotronVideo from './JumbotronVideo'

export default JumbotronVideo
// eslint-disable-next-line import/export
export * from './JumbotronVideo'
